import Main from './main.vue';

let instance;
let instances = [];

let ShareConstructor = Vue.extend(Main);

const Share = function (options) {
    // debugger
    // let calkBack = options && options[0] && options[0].callback || null
    // let data = options && options[0] && options[0].data || null
    if (instance) {
        instance.shareEvent(options)
        return
    }
    instance = new ShareConstructor({
        mounted() {
            instance.shareEvent(options)
        }
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instances.push(instance);
    return instance;
};

export default Share;